import * as countryCodes from "./CountryCodes/index";
import { css } from "styled-components";

export type Viewbox = [number, number, number, number];

export const MAX_MAP_HEIGHT = 710;
export const MAX_MAP_WIDTH = 1120;

export enum Continent {
  NorthAmerica = "North America",
  SouthAmerica = "South America",
  Oceania = "Oceania",
  Europe = "Europe",
  Asia = "Asia",
  Africa = "Africa",
  WorldMap = "World map",
}

export const continentViewBoxes: Record<Continent, Viewbox> = {
  [Continent.NorthAmerica]: [-80, 130, 510, 490],
  [Continent.Europe]: [300, 140, 370, 1000],
  [Continent.SouthAmerica]: [-30, 390, 490, 300],
  [Continent.Asia]: [560, 250, 380, 520],
  [Continent.Africa]: [270, 345, 400, 300],
  [Continent.Oceania]: [730, 450, 290, 240],
  [Continent.WorldMap]: [-320, -80, 1350, 1000],
};

export const continentCodeNames: Record<Continent, string[]> = {
  [Continent.NorthAmerica]: countryCodes.NORTH_AMERICA_CODES,
  [Continent.Europe]: countryCodes.EUROPE_CODES,
  [Continent.SouthAmerica]: countryCodes.SOUTH_AMERICA_CODES,
  [Continent.Asia]: countryCodes.ASIA_CODES,
  [Continent.Africa]: countryCodes.AFRICA_CODES,
  [Continent.Oceania]: countryCodes.OCEANIA_CODES,
  [Continent.WorldMap]: [
    ...countryCodes.NORTH_AMERICA_CODES,
    ...countryCodes.EUROPE_CODES,
    ...countryCodes.SOUTH_AMERICA_CODES,
    ...countryCodes.ASIA_CODES,
    ...countryCodes.AFRICA_CODES,
    ...countryCodes.OCEANIA_CODES,
  ],
};

export const countryWithoutRewardsStyle = css`
  fill: #b3fae1;
  stroke: #89eac7;
`;

export const countryWithRewardsStyle = css`
  fill: #43cd9b;
  stroke: #68dcb2;
`;

export const countryHoverStyle = css`
  fill: #28a87f;
  stroke: #28a87f;
  cursor: pointer;
`;

export const continentMouseEnterStyle = css`
  fill: #28a87f;
  stroke: #68dcb2;
  cursor: pointer;
`;

export const continentMouseOutStyle = css`
  fill: #43cd9b;
  stroke: #68dcb2;
`;
